import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { RatingState } from './rating.types';

const initialState: RatingState = {
  name: '',
  phone: '',
  policyChecked: false,
};

export const ratingSlice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    setRatingName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setRatingPhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload;
    },
    toggleRatingPolicy: (state) => {
      state.policyChecked = !state.policyChecked;
    },

    clearRating: (state) => {
      state.name = '';
      state.phone = '';
      state.policyChecked = false;
    },
  },
});

export const {
  setRatingName,
  setRatingPhone,
  toggleRatingPolicy,

  clearRating,
} = ratingSlice.actions;

export const selectRating = (state: RootState) => state.rating;

export const ratingReducer = ratingSlice.reducer;
